import {gql} from '@apollo/client';

import Like from './like';
import Image from './image';

export const Comment = gql`
    fragment Comment on Comment {
        behaviors {
            id: behaviorId
        }
        body
        id
        likes {
            count
            likedByMe
            likes {
                ...Like
            }
        }
        sentAt
        sentBy {
            name {
                fullName
            }
            profileImage {
                url
            }
        }
        canReport
    }
    ${Like}
`;

export const CommentWithImages = gql`
    fragment CommentWithImages on Comment {
        behaviors {
            id: behaviorId
        }
        body
        id
        likes {
            count
            likedByMe
            likes {
                ...Like
            }
        }
        sentAt
        sentBy {
            name {
                fullName
            }
            profileImage {
                url
            }
        }
        images {
            ...Image
        }
        canReport
    }
    ${Image}
    ${Like}
`;
